import styled from 'styled-components';
import {
  SkeletonHeader,
  SkeletonPage,
  SkeletonSurface
} from 'components/Skeleton/styled';

export const PageWrapper = styled(SkeletonPage).attrs({})``;

export const HeaderContent = styled(SkeletonHeader).attrs({})``;

export const SectionCard = styled(SkeletonSurface).attrs({})`
  padding: 24px 20px;
`;

export const FieldGrid = styled.div.attrs({})`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 767px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const ActionsRow = styled.div.attrs({})`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  flex-wrap: wrap;
`;
